export default __webpack_public_path__ + "static/Birdie-e7e4f459b6c0d385a5f72144e1130c66.jpg";